import { AnchorLinks } from '@thd-olt-component-react/anchor-links';
import { ComponentSelector } from '@thd-olt-component-react/component-selector';
import { ContentSection } from '@thd-olt-component-react/content-section';
import { Hero } from '@thd-olt-component-react/hero';
import { Resource } from '@thd-olt-component-react/resource';
import { ProductShelf } from '@thd-olt-component-react/product-shelf';
import { Spotlight, SpotlightContainer } from '@thd-olt-component-react/spotlight';
import { SpotlightRichText } from '@thd-olt-component-react/spotlight_rich_text';
import { SideNavigation } from '@thd-olt-component-react/side-navigation';
import { MedioInline } from '@thd-olt-component-react/internal-marketing-banner';
import { ContentAccordion } from '@thd-olt-component-react/content-accordion';

const buildComponentMapperObj = () => {
  const contentfulTypeToComponentMap = {
    AnchorLinks,
    CarouselBanner: ContentSection,
    ComponentSelector,
    ContentAccordion,
    Hero,
    HeroCarousel: ContentSection,
    ProductShelf,
    Resource,
    SpotlightSection: ContentSection,
    SpotlightRichTextSection: ContentSection,
    SpotlightExtendedSection: ContentSection,
    Section: ContentSection,
    Spotlight,
    SpotlightContainer,
    SpotlightRichText,
    SideNavigation,
    MedioInline
  };

  const contentfulKeyToContentKeyMap = {
    linkPills: 'AnchorLinks',
    contentAccordion: 'ContentAccordion',
    carouselBanner: 'CarouselBanner',
    heroCarousel: 'HeroCarousel',
    productShelf: 'ProductShelf',
    resourcesSection: 'ResourcesSection',
    spotlightSection: 'SpotlightSection',
    spotlightRichTextSection: 'SpotlightRichTextSection',
    spotlightExtendedSection: 'SpotlightExtendedSection',
    medioInline: 'MedioInline',
    sideNavigation: 'SideNavigation',
  };

  const contentfulKeys = Object.keys(contentfulKeyToContentKeyMap);

  return {
    getComponentMap: () => {
      return contentfulTypeToComponentMap;
    },
    getComponent: (contentfulType) => {
      return contentfulTypeToComponentMap[contentfulType];
    },
    isValidKey: (contentfulKey) => {
      return contentfulKeys.includes(contentfulKey);
    },
    getContentKey: (contentfulKey) => {
      return contentfulKeyToContentKeyMap[contentfulKey];
    }
  };
};

export const componentMapper = buildComponentMapperObj();
